import {getUserForApp} from "../../api/member/user";
import {getUserInfo} from "../../api/member/user";
const user = {
    state: {
        roles: [],  //角色
        menus: [],  //菜单权限
        permissions: [], //权限标识符
        modules: [],  //模块
        inspectionRoles: [], //检验检测角色
        memberUser: { //用户基本信息
            id: '',
            nickname: '',
            avatar: '',
            corporateId: '',
            corporateName: ''
        },
        projectIds: [], //绑定项目
    },
    actions: {
        loadUser({commit}){
            return new Promise((resolve, reject) => {
                getUserInfo().then(suc => {
                    // 添加数据结构检查
                    if (!suc || !suc.data || !suc.data.data || !suc.data.data.user) {
                        console.error('用户数据结构错误:', suc);
                        resolve(); // 即使出错也resolve，避免阻断应用
                        return;
                    }
                    
                    const {id,nickname,avatar,corporateId,corporateName,inspectionRole,projectIds} = suc.data.data.user
                    if(inspectionRole) {
                        const inspectionRoles = inspectionRole.split(",")
                        commit('SET_INSPECTION_ROLES',inspectionRoles)
                    }
                    if(projectIds) {
                        commit('SET_PROJECTIDS',projectIds.split(","))
                    }
                    commit('SET_MEMBER_USER', {id,nickname,avatar,corporateId,corporateName})
                    if(suc.data.data.menus && suc.data.data.menus.length > 0) {
                        commit('SET_MENUS',suc.data.data.menus)
                    }
                    resolve()
                }).catch(err => {
                    console.error('加载用户信息失败:', err);
                    resolve(); // 即使出错也resolve，避免阻断应用
                })
            })
        }
    },
    mutations: {
        SET_ROLES(state, value) {
            state.roles = value
        },
        SET_MENUS(state, value) {
            //赋值的同时给权限标识符赋值
            const permissions = value.map(v => {
                return v.permission
            }).filter(f => f)
            state.permissions = permissions
            state.menus = value;
        },
        SET_INSPECTION_ROLES(state, value) {
            state.inspectionRoles = value;
        },
        SET_MEMBER_USER(state, value) {
            state.memberUser = value;
        },
        SET_PROJECTIDS(state, value) {
            state.projectIds = value;
        },

    },
    namespaced: true
}
export default user